import React, { ComponentProps, useLayoutEffect, useRef } from 'react'
import RangeSlider from 'react-rangeslider'

// react-rangeslider puts aria-valuemin / max / now / orientation on the outer
// .rangeslider div, which has no role="slider" — axe's aria-allowed-attr rule
// (correctly) flags this as a WCAG 2.1 AA violation. Move the attrs onto the
// focusable .rangeslider__handle and add role="slider" there.
const SLIDER_ARIA_ATTRS = ['aria-valuemin', 'aria-valuemax', 'aria-valuenow', 'aria-orientation'] as const

type Props = ComponentProps<typeof RangeSlider> & { ariaLabel?: string }

export default function AccessibleSlider({ ariaLabel, ...props }: Props) {
	const ref = useRef<{ slider?: HTMLElement; handle?: HTMLElement } | null>(null)

	useLayoutEffect(() => {
		const root = ref.current?.slider
		const handle = ref.current?.handle
		if (!root || !handle) return

		for (const attr of SLIDER_ARIA_ATTRS) {
			const value = root.getAttribute(attr)
			if (value !== null) {
				handle.setAttribute(attr, value)
				root.removeAttribute(attr)
			}
		}
		handle.setAttribute('role', 'slider')
		if (ariaLabel) handle.setAttribute('aria-label', ariaLabel)
	})

	return <RangeSlider ref={ref} {...props} />
}
